<template>
  <div class="width-full h-fullVh bt relative">
    <!-- 分类 tab -->
    <md-tabbar
      v-model="headerTabId"
      indicatorColor="#171A1D"
      v-if="headerTabList && headerTabList.length > 1 && !myRole"
    >
      <md-tabbar-item
        v-for="item in headerTabList"
        :key="item.id"
        :name="item.id"
      >
        {{ item.name }}
      </md-tabbar-item>
    </md-tabbar>
    <!-- 分类 tab -->
    <!--  -->
    <div class="pt-12 bg-F2F2F6 p-0-16">
      <template
        v-if="
          headerTabId === (headerTabList[0] || {}).id &&
          (curIsAdmin || curIsCampusHeadmaster) &&
          !myRole
        "
      >
        <div
          class="font-28 c-171A1D-40 lh-36"
          v-if="curIsAdmin || curIsCampusHeadmaster"
          >人脸录入</div
        >
        <entryInfo-card
          :centerInfo="faceInfo"
          :title="curIsAdmin ? '人脸录入管理（全机构）' : '人脸录入管理'"
          type="person"
          v-if="curIsAdmin || curIsCampusHeadmaster"
          @click="handlerClick"
          class="mb-12"
        ></entryInfo-card>
        <div class="font-28 c-171A1D-40 lh-36">身份信息录入</div>
        <entryInfo-card
          class="mb-12"
          :centerInfo="teacherInfo"
          v-if="curIsAdmin"
          @click="handlerDetail('/entryInformation/org/0')"
          title="教职工信息管理"
        ></entryInfo-card>
        <template v-if="curIsAdmin">
          <entryInfo-card
            class="mb-12"
            :centerInfo="studentInfo"
            @click="handlerDetail('/entryInformation/homeSchool/student/0')"
            title="学生信息管理"
          ></entryInfo-card>

          <entryInfo-card
            class="mb-12"
            :centerInfo="guardianInfo"
            @click="handlerDetail('/entryInformation/homeSchool/guardian/0')"
            title="家长信息管理"
          ></entryInfo-card>
        </template>
        <template v-else>
          <entryInfo-card
            class="mb-12"
            :centerInfo="studentInfo"
            @click="
              handlerDetail('/entryInformation/homeSchool/classStudent/0')
            "
            title="学生信息管理"
          ></entryInfo-card>

          <entryInfo-card
            class="mb-12"
            :centerInfo="guardianInfo"
            @click="
              handlerDetail('/entryInformation/homeSchool/classGuardian/0')
            "
            title="家长信息管理"
          ></entryInfo-card>
        </template>
      </template>
      <template
        v-else-if="
          headerTabId === (headerTabList[1] || {}).id ||
          headerTabList.length < 2 ||
          myRole
        "
      >
        <div
          class="bg-FFFFFF p-22-0 p-0-16 fb fb-main-between fb-cross-center bd-radio-8 mb-12"
        >
          <div class="font-34 c-191F25 fb fb-main-between fb-cross-center">
            <img
              src="@/assets/images/face/face-ID.png"
              class="w-24"
              alt=""
              srcset=""
            />
            <span class="ml-12" v-if="userInfo.verifyFaceState"
              >人脸已录入</span
            >
            <span class="ml-12" v-else>人脸未录入</span>
          </div>
          <div
            class="c-171A1D-40 font-34"
            @click="jumpToVerifyFace"
            v-if="userInfo.verifyFaceState"
          >
            <i class="iconfont">&#xe66b;</i>
          </div>
          <div class="more-button font-28" @click="jumpToVerifyFace" v-else
            >前往录入</div
          >
        </div>
        <div
          class="bg-FFFFFF p-22-0 p-0-16 fb fb-main-between fb-cross-center bd-radio-8"
          @click="toBePerfect"
        >
          <div class="font-34 c-191F25 fb fb-main-between fb-cross-center">
            <img
              src="@/assets/images/face/face-identity.png"
              class="w-24"
              alt=""
              srcset=""
            />
            <span class="ml-12">身份信息管理</span>
          </div>
          <div class="c-171A1D-40 font-34">
            <span class="mr-4" v-if="!userInfo.identityStatus">待完善</span>
            <i class="iconfont">&#xe66b;</i>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import entryInfoCard from '@/components/entryInfoCard.vue'
import mixin from '@/mixin'
import roleTab from '@/mixin/roleTab'
import { mcOpenLink, mcToast } from '@/utils/mcSdkUtils'
import API from '@/api'
import { LEAVE_ROLE, ROOT_PATH } from '@/utils/constUtils'
import { getItem, removeItem, setItem, enterFace } from '@/utils/comUtils'
const CLASSRANK_CACHED_KEY = 'CLASSRANK_CACHED'
export default {
  name: 'PageFaceIndex',
  mixins: [mixin, roleTab],
  components: {
    entryInfoCard
  },
  data() {
    return {
      LEAVE_ROLE,
      faceSourceType: 0, // 1:ding人脸库，2：魔方人脸库 3: 拱墅人脸库
      faceInfo: [
        {
          title: '已录入/全部成员：',
          num: '0/0'
        },
        {
          title: '学生已录入/总数：',
          num: '0/0'
        }
      ],
      studentInfo: [
        {
          title: '已录入/总数：',
          num: '0/0'
        }
      ],
      teacherInfo: [
        {
          title: '已录入/总数：',
          num: '0/0'
        }
      ],
      guardianInfo: [
        {
          title: '已录入/总数：',
          num: '0/0'
        }
      ],
      userInfo: {
        memberId: this.$store.getters.orgUserId
      },
      classStudentInfo: {},
      classGuardianInfo: {},
      picker: null,
      myRole: (this.$route.query || {}).myRole
    }
  },
  async created() {
    if (+this.currentRole === LEAVE_ROLE.guardian) {
      this.$router.replace({
        name: 'PageEntryInformationGuardian'
      })
      return
    }
    this.$store.commit('setHistory', [])
    const { headerTabId } = this.getCachedData()
    this.createHeaderTab('face', headerTabId)
    this.getSchoolUserInfo()
    // 管理员
    if (this.curIsAdmin) {
      this.getCountGuardian()
      this.getCountStaff()
      this.getCountStudent()
      this.getOrgFaceStatistic()
      this.getStudentFaceCount()
    } else if (this.curIsCampusHeadmaster) {
      try {
        await this.getCountGuardian()
        await this.getCountStudent()
      } catch (error) {}
      this.$nextTick(() => {
        this.faceInfo[0].num =
          this.classStudentInfo.alreadyCount +
          this.classGuardianInfo.alreadyCount +
          '/' +
          (this.classStudentInfo.totalCount + this.classGuardianInfo.totalCount)
        this.faceInfo[1].num =
          this.classStudentInfo.alreadyCount +
          '/' +
          this.classStudentInfo.totalCount
      })
    } else if (this.myRole === '1') {
      this.headerTabId = 1
    }
    this.getApi('getFaceSource', {}).then(res => {
      this.faceSourceType = +res
    })
  },
  methods: {
    getCachedData() {
      return getItem(CLASSRANK_CACHED_KEY) || {}
    },
    setCachedData(newVal = {}) {
      setItem(CLASSRANK_CACHED_KEY, {
        ...this.getCachedData(),
        ...newVal
      })
    },
    removeCachedData() {
      removeItem(CLASSRANK_CACHED_KEY)
    },
    toBePerfect() {
      this.$router.push({
        name: 'PageEntryInformationForm',
        query: this.userInfo
      })
    },
    /**
     * 跳转录脸页面
     */
    jumpToVerifyFace() {
      mcOpenLink({
        url: enterFace(this.faceSourceType, this.corpId, 5)
      })
    },
    getSchoolUserInfo() {
      let userType = 1
      if (this.currentRole === LEAVE_ROLE.classTeacher) {
        userType = 1
      } else if (this.currentRole === LEAVE_ROLE.guardian) {
        userType = 2
      }
      return new Promise((resolve, reject) => {
        API.getSchoolUserInfo({
          campusId: this.campusId,
          memberId: this.$store.getters.orgUserId,
          userType
        })
          .then(res => {
            if (res && res.result && res.result !== '0') {
              return false
            }
            this.userInfo = res
            this.userInfo.userType = userType
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 学生已录入/总数
    getStudentFaceCount() {
      return new Promise((resolve, reject) => {
        API.getStudentFaceCount({
          campusId: this.campusId,
          operUserRoleTypes: this.currentRole
        })
          .then(res => {
            if (res && res.result && res.result !== '0') {
              return false
            }
            this.faceInfo[1].num = `${res.alreadyCount}/${res.totalCount}`
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 获取当前机构的人脸录入统计
    getOrgFaceStatistic() {
      return new Promise((resolve, reject) => {
        API.getUserFaceStatistic({
          orgId: this.orgId,
          operUserRoleTypes: this.currentRole
        })
          .then(res => {
            if (res && res.result && res.result !== '0') {
              return false
            }
            this.faceInfo[0].num = `${res.alreadyCount}/${res.totalCount}`
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    getCountGuardian() {
      let classIds = []
      if (this.curIsCampusHeadmaster && !this.curIsAdmin) {
        classIds = this.$store.getters.headmasterClass
          .find(item => item.tpId === this.campusId)
          .schoolClassDtoList.map(item => item.tpId)
      }
      return new Promise((resolve, reject) => {
        API.getCountGuardian({
          campusId: this.campusId,
          operUserRoleTypes: this.currentRole,
          memberIds: [this.dingUserId],
          classIds
        })
          .then(res => {
            if (res && res.result && res.result !== '0') {
              reject(res)
              return false
            }
            this.guardianInfo[0].num = `${res.alreadyCount}/${res.totalCount}`
            this.classGuardianInfo = res
            resolve(res)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },
    getCountStaff() {
      return new Promise((resolve, reject) => {
        API.getCountStaff({
          campusId: this.campusId,
          operUserRoleTypes: this.currentRole,
          memberIds: [this.dingUserId]
        })
          .then(res => {
            if (res && res.result && res.result !== '0') {
              return false
            }
            this.teacherInfo[0].num = `${res.alreadyCount}/${res.totalCount}`
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    getCountStudent() {
      let classIds = []
      if (this.curIsCampusHeadmaster && !this.curIsAdmin) {
        classIds = this.$store.getters.headmasterClass
          .find(item => item.tpId === this.campusId)
          .schoolClassDtoList.map(item => item.tpId)
      }
      return new Promise((resolve, reject) => {
        API.getCountStudent({
          campusId: this.campusId,
          operUserRoleTypes: this.currentRole,
          classIds
        })
          .then(res => {
            if (res && res.result && res.result !== '0') {
              reject(res)
            } else {
              this.studentInfo[0].num = `${res.alreadyCount}/${res.totalCount}`
              this.classStudentInfo = res
              resolve(res)
            }
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },
    handlerClick() {
      if (this.curIsAdmin) {
        // devServId=56&source=devServId 钉钉给d2配置识别参数
        mcOpenLink({
          url: enterFace(this.faceSourceType, this.corpId, 3, this.appId)
        })
      } else {
        if (!this.classList.length) {
          return mcToast({ msg: '暂无任课班级' })
        }
        let _crumbs = this.classList.map(res => {
          return {
            name: res.name,
            id: res.tpId
          }
        })
        if (this.classList.length > 1) {
          const _that = this
          if (this.picker) {
            return this.picker.show()
          }
          this.picker = this.$Picker({
            $props: {
              columns: _crumbs,
              defaultActive: 0
            },
            $events: {
              confirm(index, value) {
                _that.gotoFaceForHeaderMatser(value)
                _that.picker && _that.picker.hide()
              }
            }
          }).show()
        } else {
          this.gotoFaceForHeaderMatser(_crumbs)
        }
      }
    },
    gotoFaceForHeaderMatser(_crumbs) {
      const { id } = _crumbs[0] || {}
      let _url = enterFace(
        this.faceSourceType,
        this.corpId,
        2,
        this.appId,
        `&isTeacher=true#/?crumbs=${encodeURI(
          JSON.stringify(_crumbs)
        )}&groupId=${id}`
      )
      mcOpenLink({
        url: _url
      })
    },
    handlerDetail(detail) {
      this.$router.push({
        path: detail
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to && to.path === ROOT_PATH) {
      this.removeCachedData()
    } else {
      // 记录缓存数据
      this.setCachedData({
        headerTabId: this.headerTabId
      })
    }
    next()
  }
}
</script>

<style lang="scss" scoped>
.bg-F2F2F6 {
  background: #f2f2f6;
}
.more-button {
  background: #006afe;
  border-radius: 6px;
  padding: 7px 16px;
  color: #fff;
}
</style>
